import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
// import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
// import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';

const AddNewPreventiveCare = (props) => {
    const { isOpenPreventiveCare, onClose, preventiveCareData, setIsRecordSaved, onDeletePreventiveCare, patientID, IsEditAllowed } = { ...props }
    const API_URL = enumUtil.controller.General
    let PreventiveCare_Modal = {
        Notes: preventiveCareData.Notes || "",
    }
    let PreventiveCare_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [preventiveCareID, setPreventiveCareID] = useState();
    const [preventiveCareValidationModal, setPreventiveCareValidationModal] = useState(ValidationModal)
    const [preventiveCareSaveUpdateModal, setPreventiveCareSaveUpdateModal] = useState({})
    const [mainPreventiveCareModal, setMainPreventiveCareModal] = useState(PreventiveCare_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onPreventiveCareSaved, setOnPreventiveCareSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (preventiveCareData.PatientHistoryID != null) {
            setDel(true)
            setPreventiveCareID(preventiveCareData.PatientHistoryID)
        } else {
            if (!onPreventiveCareSaved) {
                setPreventiveCareID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(preventiveCareID)) {
            // setIsLoading(true)
            // ServerRequestProtected(API_URL + "/FindByID", 'post', {
            //     "ID": preventiveCareID,
            //     "TableName": enumUtil.enumAPITableName.PreventiveCare
            // }).then((response) => {
            //     setIsLoading(false);
            //     setMainPreventiveCareModal(response);
            // }).catch((error) => {
            //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            //     setIsLoading(false)
            // })
        }
    }, [preventiveCareID])

    const PreventiveCareValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainPreventiveCareModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setPreventiveCareValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewPreventiveCare = () => {
        props.setPreventiveCareData({ PatientHistoryID: null })
        setPreventiveCareID(null)
        handleClear();
    }
    const handleSavePreventiveCare = async (type) => {
        if(!IsEditAllowed) return;
        await PreventiveCareValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setPreventiveCareSaveUpdateModal(preventiveCareSaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Past Medical History",
                HistorySubType: "Preventive Care",
                ...preventiveCareSaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: preventiveCareID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setPreventiveCareID(response.id)
                        setOnPreventiveCareSaved(true)
                        if (type === "Add Another") {
                            addNewPreventiveCare();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(preventiveCareID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }

    const handleClear = () => {
        setMainPreventiveCareModal(PreventiveCare_Modal_Default);
        setPreventiveCareSaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainPreventiveCareModal };
        let saveModal = { ...preventiveCareSaveUpdateModal }
        modal[name] = value
        setMainPreventiveCareModal(modal)
        for (var property in PreventiveCare_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPreventiveCareSaveUpdateModal(saveModal)
    }

    const PreventiveCareName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainPreventiveCareModal.Notes]);
    return (
        <Modal show={isOpenPreventiveCare} onHide={isOpenPreventiveCare} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={PreventiveCareName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className='patient_payment_tabs'>
                        <div className={`input my-2 ${preventiveCareValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Preventive Care</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainPreventiveCareModal.Notes}
                            />
                            {preventiveCareValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSavePreventiveCare("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSavePreventiveCare}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewPreventiveCare